import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Button,
  makeStyles,
  Modal,
  Backdrop,
  Fade,
  Menu,
  MenuItem,
} from "@material-ui/core";

import useGetWindowWidth from "../../utils/useGetWindowWidth";
import WindowSize from "../../constants/WindowSize";
import logo from "../../assets/logos/logo-blackbolt.png";
import iconMenu from "../../assets/icons/icon_menu.svg";
import iconClose from "../../assets/icons/icon_close.svg";
import store from "../../store/store";
import UserProfile from "../../../app/partials/layout/UserProfile";
import { RiLoginBoxLine, RiLogoutBoxRLine } from "react-icons/ri";
import { Container, ContainerMobile } from "./styles";

const HeaderLanding = () => {
  const [showModal, setShowModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { auth } = store.getState();
  const width = useGetWindowWidth();
  const history = useHistory();

  const useStyles = makeStyles({
    root: {
      borderRadius: 3,
      minWidth: 0,
      padding: 4,
    },
    modal: {
      display: "block",
      position: "absolute",
      zIndex: 1,
      marginTop: width > WindowSize.MD ? 114 : 94,
      width: width > WindowSize.MD ? "30%" : "80%",
    },
    menu: {
      marginLeft: 26,
      marginTop: 10,
    },
    menuItem: {
      width: 210,
      marginRight: 8,
      marginLeft: 8,
      color: "#6d6d6d",
    },
  });

  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Container>
      <Link to="/">
        <img src={logo} className="logo-header" alt="Logo Blackbolt" />
      </Link>

      {width >= WindowSize.MD && (
        <ul>
          <li className="nav-item">
            <a href="#section2">Como funciona</a>
          </li>
          <li className="nav-item">
            <a href="#section3">Quem somos</a>
          </li>
          <li className="nav-item">
            <a href="https://www.facebook.com/MutantOficial/" target="_blank">
              <img
                className="social-icon"
                src="/images/icons/facebook.svg"
                alt=""
              />
            </a>

            <a
              href="https://www.linkedin.com/company/mutantbr/"
              target="_blank"
            >
              <img
                className="social-icon"
                src="/images/icons/linkedin.svg"
                alt=""
              />
            </a>

            <a
              href="https://www.youtube.com/channel/UCXlBZ91AvZPwutQDMzk7ETQ"
              target="_blank"
            >
              <img
                className="social-icon"
                src="/images/icons/youtube.svg"
                alt=""
              />
            </a>

            <a href="https://br.pinterest.com/mutantbr/" target="_blank">
              <img
                className="social-icon"
                src="/images/icons/pinterest.svg"
                alt=""
              />
            </a>
          </li>
          {auth?.user && auth.user.role === "ADMIN" && (
            <li>
              <Button
                onClick={() => { window.location.href = `${process.env.REACT_APP_GRAFANA_URL}/login` }}
                className="button-menu-header"
              >
                Grafana
              </Button>
            </li>
          )}
          {auth?.user ? (
            <li>
              <Button
                onClick={() => history.push("/dashboard")}
                className="button-menu-header"
              >
                Dashboard
              </Button>
            </li>
          ) : (
            <li>
              <Button
                onClick={() => history.push("/auth")}
                className="button-menu-header"
              >
                Login
              </Button>
            </li>
          )}
        </ul>
      )}

      {width < WindowSize.MD && (
        <Button
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={(event) =>
            width >= WindowSize.MD
              ? handleClick(event)
              : setShowModal(!showModal)
          }
          className={classes.root}
        >
          <img src={iconMenu} alt="Ícone Menu" />
        </Button>
      )}

      <Menu
        className={classes.menu}
        getContentAnchorEl={null}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem
          className={classes.menuItem}
          onClick={() => history.push("/auth")}
        >
          Acesso interno
        </MenuItem>
      </Menu>

      <Modal
        closeAfterTransition
        BackdropProps={{
          style: { marginTop: width > WindowSize.MD ? 98 : 68 },
          timeout: 500,
        }}
        BackdropComponent={Backdrop}
        className={classes.modal}
        onClose={() => setShowModal(false)}
        open={showModal}
      >
        <Fade in={showModal}>
          <ContainerMobile>
            <ul>
              <li>
                <Button
                  onClick={() => setShowModal(false)}
                  className={classes.root}
                >
                  <img src={iconClose} alt="Ícone fechar menu" />
                </Button>
              </li>
              <div className="dropdown-divider m-0"></div>
              <div className="dropdown-divider m-0"></div>
              {auth?.user ? (
                <>
                  <li>
                    <Link to="/auth">Acesso interno</Link>
                  </li>
                  <div className="dropdown-divider m-0"></div>
                  <li className="header-logout">
                    <Link to="/logout">
                      <span>
                        Sair <RiLogoutBoxRLine color="E60023" />
                      </span>
                    </Link>
                  </li>
                </>
              ) : (
                <li className="login-container-mobile">
                  <Link to="/auth">
                    Login <RiLoginBoxLine />
                  </Link>
                </li>
              )}
            </ul>
          </ContainerMobile>
        </Fade>
      </Modal>
    </Container>
  );
};

export default HeaderLanding;
